exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-d107a4ca] {\n  overflow: hidden;\n}", ""]);

// exports
